<template>
    <header>
        <nav class="navbar container no-indent is-max-desktop" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
                <a class="navbar-item home" href="/" aria-label="Forside">
                    <span class="icon">
                        <Icon name="home" size="xl" />
                    </span>
                </a>
                <a class="navbar-item calendar is-hidden-desktop" href="/kalender" aria-label="Kalender">
                    <span class="icon">
                        <Icon name="calendar" />
                    </span>
                </a>
                <a
                    role="button"
                    class="navbar-burger"
                    :class="{ 'is-active': menuOpen }"
                    aria-label="menu"
                    :aria-expanded="menuOpen ? 'true' : 'false'"
                    aria-controls="navbar"
                    @click="toggleMenu"
                >
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
            </div>

            <div
                class="nav-backdrop is-hidden-desktop"
                :class="{ 'is-active': menuOpen }"
                @click="closeMenu"
            ></div>

            <div id="navbar" class="navbar-menu" :class="{ 'is-active': menuOpen }">
                <div class="nav-drawer-inner">
                    <p class="nav-section-label is-hidden-desktop">Sider</p>
                    <div class="navbar-start">
                        <a
                            v-for="page in global.navigation.pages"
                            :key="page.id"
                            :href="page.url"
                            class="navbar-item"
                            @click="closeMenu"
                        >{{ page.name }}</a>
                    </div>

                    <p class="nav-section-label is-hidden-desktop">Booking</p>
                    <div class="navbar-end">
                        <div v-if="global.user.hasOwnProperty('accessLvl') && global.user.accessLvl == 1" class="navbar-item">
                            <a
                                href="/admin"
                                class="button is-medium"
                                :class="{ 'is-nav-active': isNavActive('admin') }"
                                @click="closeMenu"
                            >Admin</a>
                        </div>
                        <div class="navbar-item">
                            <a
                                href="/kalender"
                                class="button is-medium"
                                :class="{ 'is-nav-active': isNavActive('kalender') }"
                                @click="closeMenu"
                            >Kalender</a>
                        </div>
                        <div class="navbar-item">
                            <a
                                href="/mine-bookinger"
                                class="button is-medium"
                                :class="{ 'is-nav-active': isNavActive('mine-bookinger') }"
                                @click="closeMenu"
                            >Mine bookinger</a>
                        </div>
                        <div v-if="global.user.hasOwnProperty('id')" class="navbar-item">
                            <a
                                :href="'/forbrug.php?account=' + global.user.accountGuid"
                                target="_blank"
                                class="button is-medium"
                                @click="closeMenu"
                            >Forbrug</a>
                        </div>
                    </div>

                    <div v-if="isLoggedIn" class="nav-session">
                        <div class="nav-session__row">
                            <div class="nav-session__meta">
                                <p class="nav-session__name" :title="'Id: ' + global.user.id">
                                    {{ global.user.displayName }}
                                </p>
                                <p class="nav-session__account">{{ global.user.accountName }}</p>
                            </div>
                            <button
                                type="button"
                                class="button nav-session__logout"
                                aria-label="Log ud"
                                @click="logout"
                            >
                                <Icon name="sign-out" size="sm" />
                                <span class="nav-session__logout-text">Log ud</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </header>
    <BookingCreateFab />
</template>

<script>
import { defineComponent } from 'vue'
import { useComposition } from '@/compositions/composition'
import { logout, clearLocalUser, redirectHome } from '@/auth/sessionApi'
import Icon from '@/components/Icon.vue'
import BookingCreateFab from '@/components/BookingCreateFab.vue'

export default defineComponent({
    components: {
        Icon,
        BookingCreateFab
    },
    setup() {
        const { global } = useComposition();
        return { global }
    },
    data() {
        return {
            menuOpen: false
        }
    },
    computed: {
        isLoggedIn() {
            return this.global.user && Object.prototype.hasOwnProperty.call(this.global.user, 'id')
        },
        currentPath() {
            return this.$route.path || ''
        }
    },
    watch: {
        menuOpen(open) {
            document.documentElement.classList.toggle('nav-drawer-open', open)
        }
    },
    beforeUnmount() {
        document.documentElement.classList.remove('nav-drawer-open')
    },
    methods: {
        isNavActive(section) {
            const path = this.currentPath
            if (section === 'kalender') {
                return path === '/kalender' || path.startsWith('/booking')
            }
            if (section === 'mine-bookinger') {
                return path === '/mine-bookinger' || path.startsWith('/mine-bookinger/')
            }
            if (section === 'admin') {
                return path === '/admin' || path.startsWith('/admin/')
            }
            return false
        },
        toggleMenu() {
            this.menuOpen = !this.menuOpen
        },
        closeMenu() {
            this.menuOpen = false
        },
        async logout() {
            this.closeMenu()
            try {
                await logout()
                clearLocalUser(this.global)
                redirectHome()
            } catch (error) {
                redirectHome()
            }
        }
    }
})
</script>
